import { ApiService } from "./api.service";
export default class CheckUserService extends ApiService {
  namespace = "checkUser";
  icon = "Lock";
  name = "";
  DOMAIN = -74;
  favicon = "Lock";
  Width = 500;
  action = "";

  constructor() {
    super("");
  }
}
